module.exports = __webpack_public_path__ + "src/img/arrow-grey.c2f10e19.svg";